import React from 'react';
import Link from 'next/link';
import {
    StyledDevices,
    StyledDeviceHeader,
    StyledDeviceList,
    StyledDevice,
    StyledDeviceLink,
    StyledIcon,
    StyledExternalIconText,
    StyledIconWrapper,
} from './Devices.styles';
import {
    fontWeightRegular,
    iconComputer,
    iconMobile,
    iconTv,
    iconTablet,
} from '../../../ui-components/design-tokens';
import ExternalIcon from '../../ExternalLink/ExternalIcon/ExternalIcon';

const deviceData = [
    {
        title: 'Dator',
        link: 'https://kontakt.svt.se/guide/svt-play-webb',
        iconType: [iconComputer],
    },
    {
        title: 'Mobil & platta',
        link: 'https://kontakt.svt.se/guide/svt-play-mobil-och-surfplattor',
        iconType: [iconMobile, iconTablet],
    },
    {
        title: 'TV',
        link: 'https://kontakt.svt.se/guide/svt-play-pa-tv',
        iconType: [iconTv],
    },
];

const Device = ({ title, link, iconType, onDeviceClick = null }) => (
    <StyledDevice>
        <Link
            href={link}
            passHref
            onClick={() => {
                onDeviceClick && onDeviceClick(title);
            }}
        >
            <StyledDeviceLink>
                <StyledIconWrapper>
                    {iconType.map((icon) => (
                        <StyledIcon key={`icon-${icon}`} icon={icon} />
                    ))}
                </StyledIconWrapper>
                <div>
                    <ExternalIcon aria-hidden="true" isExternal>
                        <StyledExternalIconText>{title}</StyledExternalIconText>
                    </ExternalIcon>
                </div>
            </StyledDeviceLink>
        </Link>
    </StyledDevice>
);

const Devices = ({ onDeviceClick = null }) => (
    <StyledDevices>
        <StyledDeviceHeader weight={fontWeightRegular}>
            <span>Se dina favoritprogram på</span> <span>SVT Play – När och där du vill</span>
        </StyledDeviceHeader>
        <StyledDeviceList>
            {deviceData.map((device) => (
                <Device
                    key={device.title}
                    title={device.title}
                    link={device.link}
                    iconType={device.iconType}
                    onDeviceClick={onDeviceClick}
                />
            ))}
        </StyledDeviceList>
    </StyledDevices>
);

export default Devices;
